import {BufferGeometry, Color, Float32BufferAttribute, LineBasicMaterial, LineSegments} from 'three';

class RectangleGridHelper extends LineSegments {
    constructor( inputSize = 10, inputDivisions = 10, color1 = 0x444444, color2 = 0x888888 ) {
        color1 = new Color( color1 );
        color2 = new Color( color2 );

        if (!(inputSize instanceof Array)) {
            inputSize = [inputSize, inputSize];
        }

        if (!(inputDivisions instanceof Array)) {
            inputDivisions = [inputDivisions, inputDivisions];
        }

        inputSize.splice(2);
        inputDivisions.splice(2);
        let axisCount = 2;

        const vertices = [];
        const colors = [];
        let j = 0;
        for (let axisIndex = 0; axisIndex <= axisCount-1; axisIndex++) {
            const otherAxisIndex = axisIndex === 0 ? 1 : 0;
            const size = inputSize[axisIndex];
            const divisions = inputDivisions[axisIndex];
            const otherSize = inputSize[otherAxisIndex];
            const center = divisions / 2;
            const step = size / divisions;

            for ( let i = 0, k = 0; i <= divisions; i ++, k += step ) {
                if (axisIndex === 0) {
                    vertices.push(k, 0, 0, k, 0, otherSize);
                }
                else {
                    vertices.push( 0, 0, k, otherSize, 0, k );
                }

                const color = i === center ? color1 : color2;

                color.toArray( colors, j ); j += 3;
                color.toArray( colors, j ); j += 3;
            }
        }

        const geometry = new BufferGeometry();
        geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
        geometry.setAttribute( 'color', new Float32BufferAttribute( colors, 3 ) );

        const material = new LineBasicMaterial( { vertexColors: true, toneMapped: false } );

        super( geometry, material );

        this.type = 'RectangleGridHelper';

    }
}

export {RectangleGridHelper}
